import { render, staticRenderFns } from "./UpgradeGuide.vue?vue&type=template&id=0ae2df97&scoped=true&"
import script from "./UpgradeGuide.vue?vue&type=script&lang=js&"
export * from "./UpgradeGuide.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeGuide.vue?vue&type=style&index=0&id=0ae2df97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2df97",
  null
  
)

export default component.exports